module.exports = __webpack_public_path__ + "img/services_ecommerce_xs.2565d985.png";